import type { LanguageCode } from '../types'

const en = {
    languageFailed: 'Couldn’t load this language.',
    retry: 'Try again',
    dismiss: 'Dismiss',
    crashTitle: 'This page needs a refresh.',
    crashBody: 'Reload to continue.',
    reload: 'Reload page',
    home: 'Home',
    homeLabel: 'DHTN Academy home',
}

export const systemCopy: Record<LanguageCode, typeof en> = {
    en,
    ha: {
        languageFailed: 'Ba a samu loda wannan harshe ba.',
        retry: 'Sake gwadawa',
        dismiss: 'Rufe',
        crashTitle: 'Ku sake buɗe shafin.',
        crashBody: 'Ku sake lodawa don ci gaba.',
        reload: 'Sake lodawa',
        home: 'Gida',
        homeLabel: 'Shafin farko na DHTN Academy',
    },
    ar: {
        languageFailed: 'تعذّر تحميل هذه اللغة.',
        retry: 'إعادة المحاولة',
        dismiss: 'إغلاق',
        crashTitle: 'يرجى تحديث الصفحة.',
        crashBody: 'أعيدوا تحميلها للمتابعة.',
        reload: 'تحديث الصفحة',
        home: 'الرئيسية',
        homeLabel: 'الصفحة الرئيسية لأكاديمية DHTN',
    },
}
